import Search from 'UIKit/Search'
import styled from 'styled-components'

export const AppSearch = styled(Search)`
  height: 44px;
  border-radius: ${({ theme }) => theme.radii.button};
  border: unset !important;
  background: ${({ theme }) => theme.colors.card_primary};
`
